(() => {
  const configuredAccent = document.currentScript?.dataset.accent;
  const accent = /^#[\da-f]{6}$/i.test(configuredAccent || '') ? configuredAccent : '#c32c29';
  const frameId = 'codk-full-modal-svelte';
  const styleId = 'fanaze-codking-brand';
  const frames = new WeakSet();
  const css = `
    :root, #app .modal-card, #app .phone-screen {
      --fanaze-accent: ${accent};
      --color-blue: ${accent};
      --color-blue-hover: ${accent};
      --color-primary: #191919;
      --color-primary-hover: ${accent};
      --color-text-primary: #191919;
      --color-text-secondary: #606060;
      --color-background: #fff;
      --color-background-muted: #f4f4f4;
      --surface-page: #fff;
      --surface-muted: #f4f4f4;
      --surface-sunken: #f4f4f4;
      --color-border: #d9d9d9;
      --color-border-strong: #bcbcbc;
      --color-divider: #d9d9d9;
      --hairline: #d9d9d9;
      --shadow-focus: 0 0 0 3px ${accent}33;
      --sticky-footer-button-bg: #191919;
      --sticky-footer-button-bg-hover: ${accent};
      --sticky-footer-text-color: #191919;
      --address-form-input-border-focus: ${accent};
      --radius-lg: 8px;
      --radius-md: 8px;
    }
    #app .device-frame, #app .screen-content, #app .phone-screen,
    #app .payment-brand-footer, #app .screen-header { background: #fff; }
    #app .screen-header { border-bottom: 1px solid #191919; }
    #app .logo-image--wide {
      width: 180px; max-width: 100%; height: 44px; max-height: none;
      object-fit: cover; object-position: center;
    }
    #app .header-action { color: #191919; --header-icon-color: #191919; }
    #app .promo-banner {
      background: ${accent} !important; background-image: none !important; box-shadow: none;
    }
    #app .promo-banner::before, #app .promo-banner::after { display: none; }
    #app .promo-banner__text { color: #fff !important; letter-spacing: 0; text-shadow: none; }
    #app .ck-card, #app .payment-options-section {
      border: 1px solid #d9d9d9; border-radius: 8px; box-shadow: none;
    }
    #app .payment-options-title {
      font-family: Georgia, 'Times New Roman', serif;
      font-size: 26px; font-weight: 400; line-height: 1.2;
      letter-spacing: 0; color: #191919;
    }
    #app .payment-options-header { padding-bottom: 12px; }
    #app .payment-option-card {
      border-color: #d9d9d9; border-style: solid; border-width: 1px 0 0;
      border-radius: 0; background: #fff;
    }
    #app .payment-option-card.selected {
      background: color-mix(in srgb, ${accent} 4%, white);
      box-shadow: inset 3px 0 ${accent};
    }
    #app .option-name, #app .final-price, #app .order-summary-total { color: #191919; }
    #app .option-description, #app .payment-options-perk, #app .option-note { color: #606060; }
    #app .shipping-badge {
      color: ${accent}; background: color-mix(in srgb, ${accent} 8%, white);
    }
    #app .radio-icon-bolt, #app .payment-options-bolt { filter: grayscale(1); }
    #app .trust-badges, #app .brand-footer { color: #606060; }
    #app .payment-brand-footer { border-top: 1px solid #d9d9d9; }
    #app :is(button, [role='button'], a, input):focus-visible {
      outline: 2px solid ${accent}; outline-offset: 2px;
    }
    @media (hover: hover) {
      #app .payment-option-card:hover { background: color-mix(in srgb, ${accent} 4%, white); }
    }
  `;

  function applyBranding(frame) {
    try {
      const doc = frame.contentDocument;
      if (!doc?.head || doc.getElementById(styleId)) return;
      const style = doc.createElement('style');
      style.id = styleId;
      style.textContent = css;
      doc.head.append(style);
    } catch {
      // A cross-origin checkout must keep its own styles and payment flow.
    }
  }

  function connect(frame) {
    if (!(frame instanceof HTMLIFrameElement) || frame.id !== frameId || frames.has(frame)) return;
    frames.add(frame);
    frame.addEventListener('load', () => applyBranding(frame));
    applyBranding(frame);
  }

  connect(document.getElementById(frameId));
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) connect(node);
  }).observe(document.body, { childList: true });
})();
